import { useState } from 'react';

import type { HandleChangeFilters } from 'components/PaginationControls/PaginationControls';
import { URL_PARAMS } from 'constants/urlFiltering';

export type PaginationParams = {
  page?: number;
  pageSize?: number;
};

export type PaginationState = {
  page: number;
  pageSize: number;
  handleChangeFilters: HandleChangeFilters;
};

/**
 * Manages local page + pageSize state for a single paginated table.
 * The `handleChangeFilters` callback is compatible with `PaginationControls`.
 */
export const usePaginationState = (initialPageSize = 10): PaginationState => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(initialPageSize);

  const handleChangeFilters = (param: string, value: number | string) => {
    if (param === URL_PARAMS.PAGE_SIZE) {
      setPageSize(Number(value));
      setPage(1);
    } else {
      setPage(Number(value));
    }
  };

  return { page, pageSize, handleChangeFilters };
};
